const HeaderShimmer = () => {
    return (
        <div className="list-group-item bg-transparent border-0 px-0" align="center">
            <div className="d-flex align-items-center justify-content-center gap-2">
                <div className="shimmer-wrapper" style={{ width: '40px', height: '40px', borderRadius: '50%' }}></div>
                <div className="mt-2">
                    <div className="shimmer-wrapper" style={{ width: '120px', height: '24px' }}></div>
                </div>
            </div>
            <div className="mt-1">
                <div className="shimmer-wrapper" style={{ width: '80px', height: '18px' }}></div>
            </div>
        </div>
    )
}

export default HeaderShimmer;